import { jsx, jsxs } from 'react/jsx-runtime';
import { createElement, isValidElement } from 'react';
import { useTheme } from 'react-jss';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var uid = (function () {
    return Math.random()
        .toString(36)
        .substring(6);
});

var SVG = function (_a) {
    var _b = _a.animate, animate = _b === void 0 ? true : _b, _c = _a.backgroundColor, backgroundColor = _c === void 0 ? '#f5f6f7' : _c, _d = _a.backgroundOpacity, backgroundOpacity = _d === void 0 ? 1 : _d, _e = _a.baseUrl, baseUrl = _e === void 0 ? '' : _e, children = _a.children, _f = _a.foregroundColor, foregroundColor = _f === void 0 ? '#eee' : _f, _g = _a.foregroundOpacity, foregroundOpacity = _g === void 0 ? 1 : _g, _h = _a.gradientRatio, gradientRatio = _h === void 0 ? 2 : _h, uniqueKey = _a.uniqueKey, _j = _a.rtl, rtl = _j === void 0 ? false : _j, _k = _a.speed, speed = _k === void 0 ? 1.2 : _k, _l = _a.style, style = _l === void 0 ? {} : _l, _m = _a.title, title = _m === void 0 ? 'Loading...' : _m, _o = _a.beforeMask, beforeMask = _o === void 0 ? null : _o, props = __rest(_a, ["animate", "backgroundColor", "backgroundOpacity", "baseUrl", "children", "foregroundColor", "foregroundOpacity", "gradientRatio", "uniqueKey", "rtl", "speed", "style", "title", "beforeMask"]);
    var fixedId = uniqueKey || uid();
    var idClip = "".concat(fixedId, "-diff");
    var idGradient = "".concat(fixedId, "-animated-diff");
    var idAria = "".concat(fixedId, "-aria");
    var rtlStyle = rtl ? { transform: 'scaleX(-1)' } : null;
    var dur = "".concat(speed, "s");
    var from = "".concat(gradientRatio * -1, " 0");
    var to = "".concat(gradientRatio, " 0");
    return (createElement("svg", __assign({ "aria-labelledby": idAria, role: "img", style: __assign(__assign({}, style), rtlStyle) }, props),
        title ? createElement("title", { id: idAria }, title) : null,
        beforeMask && isValidElement(beforeMask) ? beforeMask : null,
        createElement("rect", { role: "presentation", x: "0", y: "0", width: "100%", height: "100%", clipPath: "url(".concat(baseUrl, "#").concat(idClip, ")"), style: { fill: "url(".concat(baseUrl, "#").concat(idGradient, ")") } }),
        createElement("defs", null,
            createElement("clipPath", { id: idClip }, children),
            createElement("linearGradient", { id: idGradient, gradientTransform: "translate(".concat(from, ")") },
                createElement("stop", { offset: "0%", stopColor: backgroundColor, stopOpacity: backgroundOpacity }),
                createElement("stop", { offset: "50%", stopColor: foregroundColor, stopOpacity: foregroundOpacity }),
                createElement("stop", { offset: "100%", stopColor: backgroundColor, stopOpacity: backgroundOpacity }),
                animate && (createElement("animateTransform", { attributeName: "gradientTransform", type: "translate", values: "".concat(from, "; 0 0; ").concat(to), dur: dur, repeatCount: "indefinite" }))))));
};

var ContentLoader = function (props) {
    return props.children ? createElement(SVG, __assign({}, props)) : createElement(ReactContentLoaderFacebook, __assign({}, props));
};

var ReactContentLoaderFacebook = function (props) { return (createElement(ContentLoader, __assign({ viewBox: "0 0 476 124" }, props),
    createElement("rect", { x: "48", y: "8", width: "88", height: "6", rx: "3" }),
    createElement("rect", { x: "48", y: "26", width: "52", height: "6", rx: "3" }),
    createElement("rect", { x: "0", y: "56", width: "410", height: "6", rx: "3" }),
    createElement("rect", { x: "0", y: "72", width: "380", height: "6", rx: "3" }),
    createElement("rect", { x: "0", y: "88", width: "178", height: "6", rx: "3" }),
    createElement("circle", { cx: "20", cy: "20", r: "20" }))); };

var InitialComponent = function InitialComponent(_a) {
  var _b = _a.width,
    width = _b === void 0 ? 400 : _b,
    _c = _a.height,
    height = _c === void 0 ? 100 : _c;
  return jsx("rect", {
    x: "0",
    y: "0",
    width: width,
    height: height
  });
};

var SkeletonLoader = function SkeletonLoader(_a) {
  var children = _a.children,
    width = _a.width,
    height = _a.height,
    other = __rest$1(_a, ["children", "width", "height"]);
  var theme = useTheme();
  var bgColor = theme.palette.background.main;
  var fgColor = theme.palette.background.accent;
  return jsx(ContentLoader, __assign$1({
    backgroundColor: bgColor,
    foregroundColor: fgColor,
    width: width,
    height: height
  }, other, {
    children: children !== null && children !== void 0 ? children : jsx(InitialComponent, {
      width: width,
      height: height
    })
  }));
};

var SvgAvatar = function SvgAvatar() {
  return jsx(SkeletonLoader, {
    viewBox: "0 0 33 33",
    width: 33,
    height: 33,
    children: jsx("circle", {
      cx: "16.5",
      cy: "16.5",
      r: "16.5"
    })
  });
};

var SvgButton = function SvgButton() {
  return jsx(SkeletonLoader, {
    width: 142,
    height: 44,
    children: jsx("rect", {
      width: "142",
      height: "44",
      rx: "4"
    })
  });
};

var SvgCard = function SvgCard() {
  return jsx(SkeletonLoader, {
    viewBox: "0 0 260 200",
    children: jsx("rect", {
      width: "260",
      height: "200",
      rx: "16"
    })
  });
};

var SvgCheckbox = function SvgCheckbox() {
  return jsx(SkeletonLoader, {
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    children: jsx("rect", {
      width: "24",
      height: "24",
      rx: "4"
    })
  });
};

var SvgCheckboxWithLabel = function SvgCheckboxWithLabel() {
  return jsxs(SkeletonLoader, {
    viewBox: "0 0 226 24",
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M40 12C40 9.2386 42.7887 7 46.2287 7H219.387C222.826 7 225.616 9.2386 225.616 12C225.616 14.7614 222.826 17 219.387 17H46.2287C42.7887 17 40 14.7614 40 12Z"
    }), jsx("rect", {
      width: "24",
      height: "24",
      rx: "4"
    })]
  });
};

var SvgChip = function SvgChip() {
  return jsx(SkeletonLoader, {
    viewBox: "0 0 97 32",
    width: 97,
    height: 32,
    children: jsx("rect", {
      width: "97",
      height: "32",
      rx: "16"
    })
  });
};

var SvgInput = function SvgInput() {
  return jsx(SkeletonLoader, {
    viewBox: "0 0 300 44",
    children: jsx("rect", {
      width: "300",
      height: "44",
      rx: "4"
    })
  });
};

var SvgInputWithLabel = function SvgInputWithLabel() {
  return jsxs(SkeletonLoader, {
    viewBox: "0 0 300 66",
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.379562 5C0.379562 2.2386 3.16826 0 6.60827 0H179.766C183.206 0 185.995 2.2386 185.995 5C185.995 7.7614 183.206 10 179.766 10H6.60827C3.16826 10 0.379562 7.7614 0.379562 5Z"
    }), jsx("rect", {
      y: "22",
      width: "300",
      height: "44",
      rx: "4"
    })]
  });
};

var SvgLine = function SvgLine() {
  return jsx(SkeletonLoader, {
    viewBox: "0 0 287 10",
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 5C0 2.2386 2.23858 0 5 0H282C284.761 0 287 2.2386 287 5C287 7.7614 284.761 10 282 10H5C2.23858 10 0 7.7614 0 5Z"
    })
  });
};

var SvgRadio = function SvgRadio() {
  return jsx(SkeletonLoader, {
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    children: jsx("rect", {
      width: "24",
      height: "24",
      rx: "12"
    })
  });
};

var SvgRadioWithText = function SvgRadioWithText() {
  return jsxs(SkeletonLoader, {
    viewBox: "0 0 226 24",
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M40 12C40 9.2386 42.7887 7 46.2287 7H219.387C222.826 7 225.616 9.2386 225.616 12C225.616 14.7614 222.826 17 219.387 17H46.2287C42.7887 17 40 14.7614 40 12Z"
    }), jsx("rect", {
      width: "24",
      height: "24",
      rx: "12"
    })]
  });
};

var SvgRectangle = function SvgRectangle() {
  return jsx(SkeletonLoader, {
    viewBox: "0 0 300 80",
    children: jsx("rect", {
      width: "300",
      height: "80"
    })
  });
};

var SvgRectangleRounded = function SvgRectangleRounded() {
  return jsx(SkeletonLoader, {
    viewBox: "0 0 300 80",
    children: jsx("rect", {
      width: "300",
      height: "80",
      rx: "4"
    })
  });
};

var SvgSection = function SvgSection() {
  return jsx(SkeletonLoader, {
    viewBox: "0 0 490 136",
    children: jsx("rect", {
      width: "490",
      height: "136"
    })
  });
};

var SvgText = function SvgText() {
  return jsxs(SkeletonLoader, {
    viewBox: "0 0 287 51",
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 25C0 22.2386 2.23858 20 5 20H282C284.761 20 287 22.2386 287 25C287 27.7614 284.761 30 282 30H5C2.23858 30 0 27.7614 0 25Z"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 5C0 2.2386 2.23858 0 5 0H282C284.761 0 287 2.2386 287 5C287 7.7614 284.761 10 282 10H5C2.23858 10 0 7.7614 0 5Z"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 46C0 43.2386 2.23858 41 5 41H144C146.761 41 149 43.2386 149 46C149 48.7614 146.761 51 144 51H5C2.23858 51 0 48.7614 0 46Z"
    })]
  });
};

var SvgTextarea = function SvgTextarea() {
  return jsx(SkeletonLoader, {
    viewBox: "0 0 300 98",
    children: jsx("rect", {
      width: "300",
      height: "98",
      rx: "4"
    })
  });
};

var SvgTextWithTitle = function SvgTextWithTitle() {
  return jsxs(SkeletonLoader, {
    viewBox: "0 0 287 85",
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 59C0 56.2386 2.23858 54 5 54H282C284.761 54 287 56.2386 287 59C287 61.7614 284.761 64 282 64H5C2.23858 64 0 61.7614 0 59Z"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 39C0 36.2386 2.23858 34 5 34H282C284.761 34 287 36.2386 287 39C287 41.7614 284.761 44 282 44H5C2.23858 44 0 41.7614 0 39Z"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 80C0 77.2386 1.9381 75 4.32886 75H124.671C127.062 75 129 77.2386 129 80C129 82.7614 127.062 85 124.671 85H4.32886C1.9381 85 0 82.7614 0 80Z"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 5C0 2.2386 2.23858 0 5 0H144C146.761 0 149 2.2386 149 5C149 7.7614 146.761 10 144 10H5C2.23858 10 0 7.7614 0 5Z"
    })]
  });
};

export { SkeletonLoader, SvgAvatar, SvgButton, SvgCard, SvgCheckbox, SvgCheckboxWithLabel, SvgChip, SvgInput, SvgInputWithLabel, SvgLine, SvgRadio, SvgRadioWithText, SvgRectangle, SvgRectangleRounded, SvgSection, SvgText, SvgTextWithTitle, SvgTextarea };
